"use client";
import ButtonWeDevlop from "./_section/button-we-develop";
import TitleSectionWeDevelop from "./_section/heading-section-we-develop";
import ReviewWidgetDemo from "./_section/review-widget-demo";
import StatsStripWeDevelop from "./_section/stats-strip-we-develop";
import SubHeadingSectionWeDevlop from "./_section/sub-heading-section-we-develop";

function WeDevelop() {
  return (
    <div className="relative min-h-[100vh] flex flex-col justify-center pt-20 md:pt-24 pb-16 overflow-hidden bg-gradient-to-br from-white via-purple-50/30 to-white">
      {/* Background Elements */}
      <div className="absolute inset-0 w-full h-full">
        {/* Grid pattern */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(82,49,231,0.02)_1.6px,transparent_1.6px),linear-gradient(to_right,rgba(82,49,231,0.02)_1.6px,transparent_1.6px)] bg-[size:24px_24px]" />

        {/* Wavy pattern under the heading */}
        <div className="hidden  md:blockabsolute top-[30%] left-1/2 -translate-x-1/2 w-full max-w-3xl">
          <svg className="w-full" viewBox="0 0 600 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 20C100 20 100 40 200 40C300 40 300 0 400 0C500 0 500 20 600 20" stroke="#E9E5FF" strokeWidth="2" />
          </svg>
        </div>
      </div>

      {/* Content Container */}
      <div className="relative z-10">
        <div
          className="container mx-auto px-4 sm:px-6 lg:px-8"
        >
          <div className="max-w-8xl mx-auto">
            <div className="space-y-6">
              {/* Top Tag */}
              <div className="flex justify-center pt-20">
                <a
                  href="/ai-engineering-squad"
                  className="inline-flex items-center gap-1.5 md:gap-2.5 px-3 py-1.5 md:px-5 md:py-2 rounded-full bg-[rgba(255,255,255,0.2)] backdrop-blur-lg border border-[#dadada] transition-all duration-300 hover:scale-103 cursor-pointer"
                >
                  <span
                    className="flex items-center gap-1 md:gap-2"
                  >
                    <span
                      className="w-2 h-2 md:w-2.5 md:h-2.5 rounded-full bg-gradient-to-r from-[#10B981] to-[#34D399]"
                    />
                    <span className="text-[#5231E7] pl-0.5 text-xs md:text-sm font-semibold tracking-wide leading-[1.1]">AI Engineering Squad</span>
                  </span>
                  <span
                    className="px-1 py-0.5 rounded-md bg-[rgba(255,230,128,0.25)] text-[#F59E0B] text-xs font-medium border border-[rgba(245,158,11,0.50)] flex items-center hover:scale-105 transition-transform"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 md:h-5 w-4 md:w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </span>
                </a>
              </div>

              {/* Main Content */}
              <div className="space-y-8 text-center">
                <TitleSectionWeDevelop />
                <SubHeadingSectionWeDevlop />
                <ButtonWeDevlop />
              </div>

              {/* Stats Strip */}
              <StatsStripWeDevelop />

              {/* Trust Badges */}
              <div>
                <div
                  className="pt-4 space-y-1 text-center"
                >
                  <h2
                    className="text-gray-600 font-medium"
                  >
                    Your Trusted Tech Partner Across the Globe
                  </h2>
                  <ReviewWidgetDemo />

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WeDevelop;
